import { ArrowRight } from "lucide-react";
import { fmtPrice } from "../../data/mock";

export const ProductCard = ({ product, pricing, saleActive, salePercent, onBuy }) => {
  const price = pricing?.amount ?? product.price;
  const strike = saleActive ? pricing?.base_amount : product.originalPrice;

  return (
    <div
      className={`relative grid md:grid-cols-2 overflow-hidden rounded-3xl border ${
        product.popular ? "border-[#2f7fff]/40" : "border-white/10"
      } bg-[#0b0d10]`}
      data-testid={`product-card-${product.id}`}
    >
      {(saleActive || product.kicker) && (
        <span className="absolute top-4 left-4 z-10 rounded-full bg-[#2f7fff] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white">
          {saleActive ? `${salePercent}% Off` : product.kicker}
        </span>
      )}
      <div className="relative aspect-square md:aspect-auto md:min-h-[420px]">
        <img
          src={product.image}
          alt={product.name}
          className="h-full w-full object-cover"
          data-testid={`product-image-${product.id}`}
        />
      </div>
      <div className="flex flex-col justify-center gap-4 p-8 sm:p-12">
        <h3 className="font-heading text-2xl sm:text-3xl text-white uppercase tracking-tight" data-testid={`product-name-${product.id}`}>
          {product.name}
        </h3>
        <p className="text-zinc-400">{product.description}</p>
        <div className="mt-2 flex items-end gap-3">
          <span className="font-heading text-4xl text-gradient-blue" data-testid={`product-price-${product.id}`}>
            {product.currency}{fmtPrice(price)}
          </span>
          {strike && (
            <span className="pb-1 text-lg text-zinc-500 line-through">
              {product.currency}{fmtPrice(strike)}
            </span>
          )}
          <span className="pb-1 text-sm text-zinc-500">AUD</span>
        </div>
        <p className="text-xs uppercase tracking-widest text-zinc-500">{product.note}</p>
        <button
          onClick={() => onBuy(product)}
          className="group mt-4 inline-flex w-fit items-center gap-2 rounded-full bg-[#2f7fff] hover:bg-[#4b91ff] text-white font-semibold px-7 py-3.5 transition-colors"
          data-testid={`buy-now-button-${product.id}`}
        >
          Buy now
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </button>
      </div>
    </div>
  );
};
